// extracted by mini-css-extract-plugin
export default {"title":"Header_title__YJ-gU","subTitleBlock":"Header_subTitleBlock__WfU5S","subTitle":"Header_subTitle__fUpiw","images":"Header_images__1n183"};